import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ContactService {
  constructor(public http: HttpClient) {}

  private header = new HttpHeaders({
    'Content-Type': 'application/json',
    'x-api-key': environment.apiKey,
  });
  public sendMailContact(
    category:  string,
    status:  string,
    subject:  string,
    lastname:  string,
    firstname:  string,
    phone_number:  string,
    email:  string,
    email_confirm:  string,
    message:  string,
    file?:  string,
    fileName?:  string,
    address?:  string,
    apprentice_firstname?:  string,
    apprentice_lastname?:  string,
    back_to_school_targeted?:  string,
    city?:  string,
    company_name?:  string,
    date_of_birth?:  string,
    diploma_targeted?:  string,
    employer?:  string,
    job_function?:  string,
    learning_master?:  string,
    place_of_birth?:  string,
    postal_code?:  string,
    rncp_code?: any,
    school_name?:  string,
    service?:  string,
    siret?:  string,
    social_reason?:  string,
    training_concerned?:  string,
    training_inProgress?:  string,
    training_proposed?: any,
    training_targeted?:  string,
    training_year?:  string,
    ufa_name?:  string,
    website?:  string,
    year?:  string
  ): Observable<any> {
    const body = {
      query: `
      mutation {
        sendMailContact(
          input: {
            category: "${category}", 
            status: "${status}", 
            subject: "${subject}", 
            lastname: "${lastname}", 
            firstname: "${firstname}", 
            phone_number: "${phone_number}", 
            email: "${email}", 
            email_confirm: "${email_confirm}", 
            message: "${message}",
            file: "${file}",
            fileName: "${fileName}",
            address: "${address}", 
            apprentice_firstname: "${apprentice_firstname}", 
            apprentice_lastname: "${apprentice_lastname}",
            back_to_school_targeted: "${back_to_school_targeted}",
            city: "${city}", 
            company_name: "${company_name}", 
            date_of_birth: "${date_of_birth}", 
            diploma_targeted: "${diploma_targeted}", 
            employer: "${employer}", 
            job_function: "${job_function}", 
            learning_master: "${learning_master}", 
            place_of_birth: "${place_of_birth}", 
            postal_code: "${postal_code}", 
            rncp_code: "${rncp_code}", 
            school_name: "${school_name}", 
            service: "${service}", 
            siret: "${siret}",
            social_reason: "${social_reason}", 
            training_concerned: "${training_concerned}", 
            training_inProgress: "${training_inProgress}", 
            training_proposed: "${training_proposed}", 
            training_targeted: "${training_targeted}", 
            training_year: "${training_year}", 
            ufa_name: "${ufa_name}", 
            website: "${website}", 
            year: "${year}"
          }) {
          code
        }
      }
      `,
    };
    return this.http.post(environment.baseUrl, body, { headers: this.header });
  }

  public applyForAnOffer(
    lastname:  string,
    firstname:  string,
    phone_number:  string,
    email:  string,
    training_inProgress:  string,
    organization_email: any,
    offer:  string,
  ): Observable<any> {
    const body = {
      query: `
        mutation {
          applyForAnOffer(
            input: {
              email: "${email}", 
              firstname: "${firstname}", 
              lastname: "${lastname}", 
              offer: "${offer}", 
              organization_email: "${organization_email}", 
              phone_number: "${phone_number}", 
              training_inProgress: "${training_inProgress}"
            }) {
            code
          }
        }        
      `,
    };
    return this.http.post(environment.baseUrl, body, { headers: this.header });
  }

  public sendMailInscription(
    address:  string,
    apply_for_an_offer:  string,
    attestation:  string,
    attestation_file_name:  string,
    city:  string,
    civility:  string,
    current_situation:  string,
    current_situation_detail:  string,
    date_of_birth:  string,
    email:  string,
    firstname:  string,
    folder_transmission:  string,
    folder_transmission_employer:  string,
    information_training_targeted:  string,
    lastname:  string,
    phone_number:  string,
    place_of_birth:  string,
    postal_code:  string,
    selection_test:  string,
    suscriber:  string,
    suscribtion_rules:  string,
    training_project:  string,
    understand_start_of_apprenticeship:  string,
    additionnal_address?:  string,
    first_file?:  string,
    first_file_name?:  string,
    rqth?:  string,
    second_file?:  string,
    second_file_name?:  string,
    suscriber_establishment?:  string,
    training_progress_diploma?: any,
    training_progress_status?: any,
    training_progress_year?: any,
  ): Observable<any> {
    const body = {
      query: `
        mutation {
          sendMailInscription(
            input: {
              address: "${address}", 
              apply_for_an_offer: "${apply_for_an_offer}", 
              attestation: "${attestation}",
              attestation_file_name: "${attestation_file_name}", 
              city: "${city}", 
              civility: "${civility}", 
              current_situation: "${current_situation}", 
              current_situation_detail: "${current_situation_detail}", 
              date_of_birth: "${date_of_birth}", 
              email: "${email}", 
              firstname: "${firstname}", 
              folder_transmission: "${folder_transmission}", 
              folder_transmission_employer: "${folder_transmission_employer}", 
              information_training_targeted: "${information_training_targeted}", 
              lastname: "${lastname}", 
              phone_number: "${phone_number}", 
              place_of_birth: "${place_of_birth}", 
              postal_code: "${postal_code}", 
              selection_test: "${selection_test}", 
              suscriber: "${suscriber}", 
              suscribtion_rules: "${suscribtion_rules}", 
              training_project: "${training_project}", 
              understand_start_of_apprenticeship: "${understand_start_of_apprenticeship}", 
              additionnal_address: "${additionnal_address}", 
              first_file: "${first_file}",
              first_file_name: "${first_file_name}", 
              rqth: "${rqth}", 
              second_file: "${second_file}",
              second_file_name: "${second_file_name}",
              suscriber_establishment: "${suscriber_establishment}", 
              training_progress_diploma: "${training_progress_diploma}", 
              training_progress_status: "${training_progress_status}", 
              training_progress_year: "${training_progress_year}"
            }) {
            code
          }
        }
        
      `,
    };
    return this.http.post(environment.baseUrl, body, { headers: this.header });
  }
}
